var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.333v5.334h4V25h5.333v-9.333h4l1.334-5.334h-5.334V7.667a1.333 1.333 0 0 1 1.334-1.334h4V1h-4A6.667 6.667 0 0 0 5 7.667v2.666H1Z",
    stroke: "#00412F"
  })));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAxNyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTAuMzMzM1YxNS42NjY3SDVWMjVIMTAuMzMzM1YxNS42NjY3SDE0LjMzMzNMMTUuNjY2NyAxMC4zMzMzSDEwLjMzMzNWNy42NjY2N0MxMC4zMzMzIDcuMzEzMDQgMTAuNDczOCA2Ljk3MzkxIDEwLjcyMzkgNi43MjM4NkMxMC45NzM5IDYuNDczODEgMTEuMzEzIDYuMzMzMzMgMTEuNjY2NyA2LjMzMzMzSDE1LjY2NjdWMUgxMS42NjY3QzkuODk4NTYgMSA4LjIwMjg2IDEuNzAyMzggNi45NTI2MiAyLjk1MjYyQzUuNzAyMzggNC4yMDI4NiA1IDUuODk4NTYgNSA3LjY2NjY3VjEwLjMzMzNIMVoiIHN0cm9rZT0iIzAwNDEyRiIvPgo8L3N2Zz4K";